import { styled } from 'styled-components'

export const LineItemCurrencyContainer = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
`
